var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H51C53.2091 0 55 1.79086 55 4C55 6.20914 53.2091 8 51 8H4C1.79086 8 0 6.20914 0 4Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5C0 10.6716 0.671573 10 1.5 10H37.5C38.3284 10 39 10.6716 39 11.5C39 12.3284 38.3284 13 37.5 13H1.5C0.671574 13 0 12.3284 0 11.5Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5C0 15.6716 0.671573 15 1.5 15H42.5C43.3284 15 44 15.6716 44 16.5C44 17.3284 43.3284 18 42.5 18H1.5C0.671574 18 0 17.3284 0 16.5Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 21.7909 1.79086 20 4 20H51C53.2091 20 55 21.7909 55 24C55 26.2091 53.2091 28 51 28H4C1.79086 28 0 26.2091 0 24Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.5C0 30.6716 0.671573 30 1.5 30H37.5C38.3284 30 39 30.6716 39 31.5C39 32.3284 38.3284 33 37.5 33H1.5C0.671574 33 0 32.3284 0 31.5Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.5C0 35.6716 0.671573 35 1.5 35H42.5C43.3284 35 44 35.6716 44 36.5C44 37.3284 43.3284 38 42.5 38H1.5C0.671574 38 0 37.3284 0 36.5Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 44C0 41.7909 1.79086 40 4 40H51C53.2091 40 55 41.7909 55 44C55 46.2091 53.2091 48 51 48H4C1.79086 48 0 46.2091 0 44Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 51.5C0 50.6716 0.671573 50 1.5 50H31.5C32.3284 50 33 50.6716 33 51.5C33 52.3284 32.3284 53 31.5 53H1.5C0.671574 53 0 52.3284 0 51.5Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/HEADER.859bed1e09f39ece1ffcea5ba4b7def5.svg";
export { ForwardRef as ReactComponent };